import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as Half } from '../../../images/show-coupon.svg';

export const ShowCouponIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} component={Half} />
);

export default ShowCouponIcon;
